import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { breakpoints, colors } from '@/styles'
import { Button } from '@/components/button-new'
import { AlertIcon } from '@/components/icons'

import makeAlertButton from './alert-button-base'

const CreateAlertWrapper = styled.div`
  ${props =>
    props.hideOnMobile &&
    `
    @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
      display: none;
    }
  `}
`

const AlertButton = styled(Button)`
  font-size: 14px;
  border-radius: 4px;
  &:not(:disabled):not([aria-disabled='true']) {
    color: ${props => (props.primary ? colors.white : colors.blue16)};
    border: 1.5px solid ${colors.blue16};
    padding: 12px 16px;
  }
`

const AlertButtonList = makeAlertButton(
  ({ hideOnMobile = true, primary = false, ...rest }) => {
    const { t } = useTranslation()
    return (
      <CreateAlertWrapper hideOnMobile={hideOnMobile}>
        <AlertButton
          {...rest}
          size="small"
          primary={primary}
          theme={primary ? 'primary' : 'secondary'}
          id="create-alert-main-click"
        >
          <AlertIcon width={12} height={16} right={4} />
          {t('filters:b.listing.alert.create.button', 'Create Alert')}
        </AlertButton>
      </CreateAlertWrapper>
    )
  },
  'AlertButtonList'
)

export default AlertButtonList
